import { createFileRoute } from '@tanstack/react-router'
import UserSettings from '../../../containers/user-settings'

export const Route = createFileRoute('/_authenticated/userSettings/')({
  component: UserSettings
})